import React, { useCallback } from 'react'

import { useSelector } from 'react-redux'

import type { RecipeUUID } from '@library/menu-service'

import { useCollection, useCurrentCollectionId } from 'hooks/menu-collections'
import { BasketContainer } from 'routes/Menu/components/Basket/BasketContainer'
import { useMenuBasketCta } from 'routes/Menu/context/menuBasketCtaContext'
import { useBasket } from 'routes/Menu/domains/basket'
import { getBasketMenuUuid } from 'selectors/basket'

import { MenuExperienceRecipeDetailOverlay } from '../MenuExperiencePage/MenuExperienceRecipeDetailOverlay'
import {
  MenuExperienceRecipeDetailProvider,
  useMenuExperienceRecipeDetails,
} from '../MenuExperiencePage/menuExperienceRecipeDetailContext'

const BasketWithMenuExperienceRecipeDetails = () => {
  const { openRecipeDetail } = useMenuExperienceRecipeDetails()
  const { labelHTML } = useMenuBasketCta()
  const handleRecipeClick = useCallback(
    (recipeId: RecipeUUID, recipeTitle: string) =>
      openRecipeDetail({
        recipeId,
        title: recipeTitle,
        source: 'basket',
      }),
    [openRecipeDetail],
  )

  return <BasketContainer basketLabelHTML={labelHTML} onRecipeClick={handleRecipeClick} />
}

export const MenuExperienceBasketContainer = () => {
  const { updateRecipePortionsByUuid } = useBasket()
  const basketMenuUuid = useSelector(getBasketMenuUuid)
  const currentCollectionId = useCurrentCollectionId()
  const currentCollection = useCollection(currentCollectionId)

  return (
    <MenuExperienceRecipeDetailProvider
      key={basketMenuUuid}
      collectionId={currentCollectionId}
      collectionSlug={currentCollection?.slug}
      menuId={basketMenuUuid}
      updateRecipePortions={updateRecipePortionsByUuid}
    >
      <BasketWithMenuExperienceRecipeDetails />
      <MenuExperienceRecipeDetailOverlay />
    </MenuExperienceRecipeDetailProvider>
  )
}
